<template>
  <div
    v-if="mainFields.code && loading.place"
    :style="{
      'background-color': useBackgroundColor,
      'padding-top': paddingTop ? paddingTop + 'px' : '',
      'padding-bottom': paddingBottom ? paddingBottom + 'px' : ''
    }"
    :class="{ disabled: loading.calculate }"
  >
    <div
      :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
      @click="$emit('block:redirect')"
    >
      <div v-if="blockParams?.filter" class="filter-block">
        <div class="filter-block__column">
          <div class="input-group">
            <div class="input-text">
              Хочу вложить
            </div>
            <div class="input-group-label">
              <input
                ref="amountInputRef"
                type="number"
                class="input"
                :value="targetPrice"
                @input="
                  changeInputWithDebounce($event)
                "
                @keypress.enter="pickUp"
              >
              <span :style="{ left: targetPrice?.toString()?.length + 'ch' }">₽</span>
            </div>
          </div>
        </div>
        <div class="filter-block__column">
          <div class="input-group">
            <div class="input-text">
              На срок
            </div>
            <select v-model="targetDeadline" class="input select">
              <option v-for="deadline in deadlines" :key="deadline" :value="+deadline">
                {{ formattedData(deadline) }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-block__column" @click="pickUp">
          <button class="btn btn--full">
            Подобрать
          </button>
        </div>
      </div>
      <div class="head">
        <div class="head-content">
          <div class="head-title">
            {{ mainFields?.title?.value }}
          </div>
        </div>
        <div v-if="tags && useBlocksFilters" class="head-aside">
          <div class="tabs">
            <tab-default
              v-for="(count, tag) in tags"
              :key="tag"
              :title="tag"
              :is-active="activeTag === tag"
              :count="count"
              @click="changeTag(tag)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div v-if="calculators.length" class="offers">
        <div v-for="calculator in calculators" :key="calculator.id">
          <div class="offer">
            <div class="offer-image">
              <img
                :src="$imageUrl({ fileId: calculator?.fileId }, 'creditDeposit', 'webp')"
                :alt="calculator.name"
                loading="lazy"
              >
            </div>
            <div class="offer-content">
              <div class="offer-text">
                <div class="offer-header">
                  <div v-if="!calculator.button2Link" class="offer-title">
                    {{ calculator.name }}
                  </div>
                  <nuxt-link v-else :to="calculator.button2Link" class="offer-title">
                    {{ calculator.name }}
                  </nuxt-link>
                  <div class="offer-info">
                    {{ calculator.description }}
                  </div>
                </div>
              </div>
              <div class="offer-price">
                <div v-if="calculator.rate" class="offer-price__item">
                  <div class="offer-price__title">
                    Ставка в год
                  </div>
                  <div class="offer-price__value">
                    <span>{{ calculator.rate }}</span>
                  </div>
                </div>

                <div v-if="calculator.deposit" class="offer-price__item">
                  <div class="offer-price__title">
                    Сумма
                  </div>
                  <div class="offer-price__value">
                    <span>{{ calculator.deposit }}</span>
                  </div>
                </div>

                <div v-if="calculator.term" class="offer-price__item">
                  <div class="offer-price__title">
                    Срок
                  </div>
                  <div class="offer-price__value">
                    <span>{{ calculator.term }}</span>
                  </div>
                </div>
              </div>
              <div class="offer-order">
                <div
                  v-if="calculator.button1Text"
                  class="btn btn--small btn--white btn--mobile-large"
                  @click="openModal(calculator.name)"
                >
                  {{ calculator.button1Text }}
                </div>
                <nuxt-link
                  v-if="calculator.button2Text"
                  :to="calculator.button2Link"
                  class="btn btn--small btn--white btn--mobile-large"
                >
                  {{ calculator.button2Text }}
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="offers">
        По данным фильтрам ничего не найдено, пожалуйста, поменяйте условия
      </div>
    </div>

    <div v-if="useShowMore" class="offset-footer center">
      <nuxt-link
        :to="{ path: showMoreLink || '/' }"
        :class="['btn btn--full btn--line', `${$attrs?.useWhiteShowMoreLinkColor ? 'btn--white' : ''}`]"
      >
        Показать ещё
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'
import TabDefault from '~/components/ui/tab/tab-default.vue'

export default {
  name: 'CalculatorList',
  components: { TabDefault },
  mixins: [staticBlockMixin],
  inject: [
    'globalFormProvider',
    'setGlobalFormProviderProperties'
  ],
  data () {
    return {
      calculators: [], // список калькуляторов
      tags: [], // список тегов
      loading: {
        place: false, // состояние загрузки страницы
        calculate: false // состояние ответа запроса калькуляации
      },
      targetPrice: 0, // выбранная цена
      targetDeadline: 0, // выбранный срок
      deadlines: [], // диапазон сроков
      borders: {}, // границы положенных допустимых значений
      selectedCard: '',
      readFilters: false,
      amountInputTimer: null
    }
  },
  async fetch () {
    // Если нет кода - выходим
    if (!this.mainFields.code) {
      return
    }

    try {
      // Получаем калькуляторы
      await this.fetchCalculators()

      // Калькулируем границы
      this.calculateRates()

      // Высчитываем диапазон сроков
      this.deadlines = this.calculateDeadline()

      // Назначаем выбранный срок как самое минимальное значение
      this.targetDeadline = this.deadlines?.[0]
      // Назначаем выбранную цену как самую минимальную
      this.targetPrice = this.borders.minPrice
    } finally {
      // Разрешаем отрисовку страницы
      this.loading.place = true
    }
  },
  computed: {
    formTypeId () {
      return this.mainFields.code?.value === 'vklady'
        ? this.$config?.app?.forms?.ids?.DEPOSIT
        : this.$config?.app?.forms?.ids?.CREDIT
    }
  },
  watch: {
    '$route.query.form' (val) {
      if (!val) { this.selectedCard = '' }
    }
  },
  methods: {
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.formTypeId,
        typeOfCard: this.selectedCard,
        productList: this.calculators,
        isLong: this.$attrs?.['is-long'] || this.blockParams?.isLong
      })
    },
    openModal (calculatorName) {
      this.selectedCard = calculatorName || this.calculator?.name
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.formTypeId } })
    },
    // Фильтруем по тегу
    async changeTag (tag) {
      // Если тег тот же что и был - выходим
      if (this.activeTag === tag) {
        return
      }

      // Назначаем новый тег
      this.activeTag = tag

      // Отправляем запрос на калькуляцию
      await this.fetchCalculators()
    },
    // Подбираем вклад
    async pickUp () {
      this.changeInput({ target: this.$refs.amountInputRef })
      // Сбрасываем тег
      this.activeTag = 'Все'

      this.readFilters = true

      // Отправляем запрос на калькуляцию
      await this.fetchCalculators()
    },
    // Запрос на калькуляцию
    async fetchCalculators () {
      // Если уже идет запрос - выходим
      if (this.loading.calculate) {
        return
      }

      // Меняем состояние запроса
      this.loading.calculate = true

      try {
        const parsedTags = []

        const filterTag = this.activeTag === 'Все'
          ? undefined
          : this.activeTag

        if (filterTag) {
          parsedTags.push(filterTag)
        }

        const stringifiedTags = parsedTags?.length ? JSON?.stringify(parsedTags) : undefined

        // Отправляем запрос с получившимися данными
        const { data } = await this.$calculator.fetchCalculators({
          type: this.mainFields.code?.value, // тип калькуляторов
          calcFor: this.mainFields?.tag?.value || undefined,
          tag: stringifiedTags,
          targetPrice: this.readFilters ? this.targetPrice : undefined,
          targetDeadline: this.readFilters ? this.targetDeadline : undefined
        })

        // Записываем данные
        this.calculators = !this.limit ? data.calculators : data.calculators.slice(0, this.limit)
        this.tags = data.tags
      } catch (error) {
        console.error(error)
      } finally {
        this.loading.calculate = false
      }
    },
    // Находим диапазоны сроков
    calculateDeadline () {
      const terms = []

      for (let i = this.borders.minRate; i <= this.borders.maxRate; i++) {
        if (
          (i <= 3) || // До 3 месяцев - по 1 месяцу
          (i <= 12 && i % 3 === 0) || // От 3 до 12 месяцев - по 3 месяца
          (i <= 24 && i % 6 === 0) || // От 1 года до 2 лет - по полгода
          (i <= 60 && i % 12 === 0) || // От 2 до 5 лет - по 1 году
          (i <= 120 && i % 60 === 0) || // От 5 до 10 лет - по 5 лет
          (i <= 240 && i % 120 === 0) // От 10 до 20 лет - по 10 лет
        ) {
          terms.push(i)
        }
      }

      return terms
    },
    // Находим границы калькуляций
    calculateRates () {
      for (const calculator of this.calculators) {
        if (this.borders.minRate === undefined || calculator.minDeadlineFrom < this.borders.minRate) {
          this.borders.minRate = calculator.minDeadlineFrom
        }

        if (this.borders.minPrice === undefined || calculator.minDeposite < this.borders.minPrice) {
          this.borders.minPrice = calculator.minDeposite
        }

        if (this.borders.maxRate === undefined || calculator.maxDeadlineFrom > this.borders.maxRate) {
          this.borders.maxRate = calculator.maxDeadlineFrom
        }

        if (this.borders.maxPrice === undefined || calculator.maxDeposite > this.borders.maxPrice) {
          this.borders.maxPrice = calculator.maxDeposite
        }
      }
    },
    // Форматируем месяцы в года
    formattedData (deadline) {
      if (deadline < 12) {
        return `${deadline} мес`
      }

      const years = deadline / 12
      const wholeYears = Math.floor(years)

      let yearsEnding

      // Проверяем, является ли число дробным
      if (years !== wholeYears) {
        yearsEnding = 'года'
      } else {
        const lastDigit = wholeYears % 10
        const lastTwoDigits = wholeYears % 100

        if (lastDigit === 1 && lastTwoDigits !== 11) {
          yearsEnding = 'год'
        } else if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 10 || lastTwoDigits >= 20)) {
          yearsEnding = 'года'
        } else {
          yearsEnding = 'лет'
        }
      }

      return `${years} ${yearsEnding}`
    },
    // Обработка изменений значения в нипуте
    changeInput ($event) {
      const value = $event.target.value

      if (value < this.borders.minPrice) {
        this.targetPrice = this.borders.minPrice
        return
      }

      if (value > this.borders.maxPrice) {
        this.targetPrice = this.borders.maxPrice
        return
      }

      this.targetPrice = value

      $event.target.value = this.targetPrice
    },

    changeInputWithDebounce ($event) {
      this.targetPrice = $event.target.value
      $event.target.value = this.targetPrice

      // if (this.amountInputTimer) { clearTimeout(this.amountInputTimer) }
      // this.amountInputTimer = setTimeout(() => {
      //   this.changeInput($event)
      //   this.amountInputTimer = null
      // }, 500)
    }
  }
}
</script>
